class ComingSoonCartCleaner {
  constructor() {
    this.jsonNode = document.getElementById('ComingSoonCartLines');
    this.keys = this.readKeys();
    if (this.keys.length) this.removeLines();
  }

  readKeys() {
    if (!this.jsonNode) return [];

    try {
      const keys = JSON.parse(this.jsonNode.textContent);
      return Array.isArray(keys) ? keys.filter(Boolean) : [];
    } catch (error) {
      return [];
    }
  }

  async removeLines() {
    const updates = {};
    this.keys.forEach((key) => {
      updates[key] = 0;
    });

    try {
      const response = await fetch(window.routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ updates }),
      });

      if (!response.ok) return;
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  }
}

document.addEventListener('submit', (event) => {
  const submitButton = event.target.querySelector('[name="add"][data-coming-soon="true"]');
  if (submitButton) event.preventDefault();
});

document.addEventListener('click', (event) => {
  const blockedControl = event.target.closest('[data-coming-soon="true"]');
  if (blockedControl) {
    event.preventDefault();
    event.stopPropagation();
  }
}, true);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ComingSoonCartCleaner());
} else {
  new ComingSoonCartCleaner();
}
